export default __webpack_public_path__ + "build/d32373b65e14c43aebbb710ca29ca7e7.svg";